// Contas "restritas" (cliente e motorista): só enxergam os veículos
// vinculados a elas e nunca as telas da equipe (Agenda, Câmera, Vendas,
// busca por cliente…). Motorista (pedido 2026-10-08) segue as mesmas
// travas do cliente — mesma regra de isClientAccount no backend
// (vehicles/client-traccar-restrictions.ts).
export function isRestrictedAccountType(accountType: string | null | undefined): boolean {
  return accountType === "usuario" || accountType === "motorista";
}
